import { Paragraph, tokens } from '@welbe/web-design-system';
import { Status } from 'App/Components/Status/Status';
import { DefaultActivity } from '../../MoreInfo';
import { workshopsHeaders } from '../../MoreInfo.constants';
import { DefaultContainer } from '../../MoreInfo.styles';
import { TableData, TableHead, TableRow } from '../TableElements/TableElements';

export const Workshops = ({ rows }: DefaultActivity) => {
	if (!rows?.length) return null;

	return (
		<DefaultContainer>
			<Paragraph fontWeight="500" color={tokens.color_primary}>
				Talleres
			</Paragraph>
			<table className="population-see-more-table">
				<TableRow>
					{workshopsHeaders.map((header) => (
						<TableHead key={header.id} id={header.id} width={header.width}>
							{header.label}
						</TableHead>
					))}
				</TableRow>
				{rows.map((row) => (
					<TableRow key={row.id}>
						<TableData>
							<Paragraph fontWeight="500" title={row.name}>
								{row.name}
							</Paragraph>
						</TableData>
						<TableData>
							<Status status={row.status || 'notApplied'} />
						</TableData>
					</TableRow>
				))}
			</table>
		</DefaultContainer>
	);
};
